// What an editor is told about where a file went on the meet page. filed_by
// comes from the meet-documents expander: auto, editor or unfiled.

// The tag on a saved file: plone.restapi sends a choice as { token, title }
const tagOf = (saved) => saved?.meet_document?.token ?? saved?.meet_document;

export const filingNote = (filedBy) =>
  ({
    auto: 'Filed automatically from the file name. Wrong? Change it here.',
    unfiled:
      "We couldn't tell what this is from its name. Choose where it goes.",
  })[filedBy] || null;

// The options for "Shown as", in the order of the page
export const filingOptions = (slots) => [
  ...slots.map(({ id, title }) => ({ id, title })),
  { id: 'other', title: 'More documents' },
];

// The message after an upload. chosen is the slot whose Upload button was
// used; with none, the server filed it from its name.
export const uploadMessage = (saved, chosen, options) => {
  const name = saved.title;
  const tag = tagOf(saved);
  const where = options.find((o) => o.id === tag)?.title;
  if (chosen) return `Added ${name} to ${where}.`;
  if (where) {
    return `${name} was filed automatically as ${where}, going by its name. If that's wrong, change it under the file.`;
  }
  return `${name} is under More documents because we couldn't tell what it is from its name. Choose where it goes under the file.`;
};

// The body that creates a File from an upload
export const fileContent = (file, base64, chosen) => ({
  '@type': 'File',
  title: file.name,
  file: {
    data: base64,
    encoding: 'base64',
    'content-type': file.type || 'application/octet-stream',
    filename: file.name,
  },
  ...(chosen ? { meet_document: chosen } : {}),
});
